import { useEffect } from 'react';

/**
 * Scroll-reveal for the marketing design system.
 * Mirrors homepage.js: observes every `.reveal` / `.fade-up` / `.scale-in`
 * inside the `.clarid-marketing` tree and adds `.in` once it scrolls into view.
 * Runs once per mount; elements already in view reveal immediately.
 */
export function useScrollReveal(deps: ReadonlyArray<unknown> = []) {
  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const els = Array.from(
      document.querySelectorAll<HTMLElement>(
        '.clarid-marketing .reveal, .clarid-marketing .fade-up, .clarid-marketing .scale-in'
      )
    );

    if (reduce) {
      els.forEach((el) => el.classList.add('in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.14 }
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
